<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="documentDialog" max-width="800">
            <v-card class="pa-3">
                <v-card-title class="headline pa-0 pb-2">{{
                    rowClicked.category
                }}</v-card-title>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Name:
                    </div>
                    <div>
                        {{ rowClicked.nameH }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2" v-if="rowClicked.hebName">
                    <div class="font-weight-medium mr-2">
                        Student Name:
                    </div>
                    <div>
                        {{ rowClicked.hebName }}
                    </div>
                </v-layout>
                <div
                    style="height: 450px; overflow-y: auto;"
                    class="mt-3"
                    v-if="rowClicked.fileURL && numPages && isPdf()"
                >
                    <!-- <pdf
                        style="max-height: 450px !important; width: 100%;"
                        :src="rowClicked.fileURL"
                    ></pdf> -->
                    <pdf
                        v-for="i in numPages"
                        :key="i"
                        :src="src"
                        :page="i"
                        style=" width: 100%;"
                    ></pdf>
                </div>
                <div
                    class="mt-3"
                    v-if="rowClicked.fileURL && isImage()"
                    style="height: 450px; overflow-y: auto;"
                >
                    <img
                        :src="rowClicked.fileURL"
                        style="max-height: 950px !important;"
                    />
                </div>
                <!-- <v-layout row class="pa-0 my-3">
                    <v-select
                        outline
                        style="width: 250px;"
                        label="Status"
                        class="mt-3 mr-3 mb-0"
                        v-model="rowClicked.status"
                        :items="['APPROVED', 'UPLOADED', 'REJECTED']"
                        ref="status"
                        hide-details
                    >
                    </v-select>
                    <v-select
                        outline
                        style="width: 250px;"
                        label="Category"
                        class="mt-3 mb-0"
                        v-model="rowClicked.category"
                        :items="[
                            'HISCYVIS',
                            'INSURANCE CARD',
                            'HEALTH FORM',
                            ' LUNCH',
                        ]"
                        ref="category"
                        hide-details
                    >
                    </v-select>
                </v-layout> -->
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeDocumentDialog"
                        >Close</v-btn
                    >
                    <!-- <v-btn :loading="processing" color="success" @click="save"
                        >Save</v-btn
                    > -->
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { formatCurrency } from "../../utils/helpers.js";
import pdf from "vue-pdf";

export default {
    components: {
        pdf,
    },
    data: () => ({
        title: "Documents",
        documentDialog: false,
        rowClicked: "",
        processing: false,

        actions: [],

        regID: "",
        url: "",
        numPages: undefined,
        src: "",

        columns: [
            // {
            //     field: "status",
            //     isIcon: true,
            //     template: "icon",
            //     alignment: "center",
            //     visible: true,
            //     allowFiltering: false,
            //     allowHeaderFiltering: false,
            //     allowHiding: false,
            //     allowSearch: false,
            //     cssClass: "width-25",
            //     icon: (value) => {
            //         if (!value) return "";

            //         switch (value.trim()) {
            //             case "UPLOADED":
            //                 return "mdi-file-upload";
            //             case "PENDING REVIEW":
            //                 return "mdi-flag-outline";
            //             case "REJECTED":
            //                 return "mdi-close-circle";
            //             case "SENT TO VAAD MISHMERES":
            //             case "SENT TO VAAD-MISHMERES":
            //                 return "mdi-email";
            //             case "IMPORTED":
            //             case "IMPORTED-SD":
            //             case "COMPLETED":
            //             case "APPROVED":
            //                 return "mdi-file-check";
            //             default:
            //                 return "";
            //         }
            //     },
            //     iconColor: (value) => {
            //         if (!value) return "";

            //         switch (value.trim()) {
            //             case "UPLOADED":
            //                 return "#aeb8bf";
            //             case "PENDING REVIEW":
            //                 return "#fdb400";
            //             case "REJECTED":
            //                 return "#f35123";
            //             case "SENT TO VAAD MISHMERES":
            //                 return "info";
            //             case "IMPORTED":
            //             case "IMPORTED-SD":
            //             case "COMPLETED":
            //             case "APPROVED":
            //                 return "success";
            //             default:
            //                 return "#aeb8bf";
            //         }
            //     },
            // },
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "nameH",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "LapidusAccountView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "hebName",
                label: "Student Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "category",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "File Name",
            //     field: "fileURL",
            //     format: "",
            //     template: "link-action-cell-template",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            //     showLink: (row) => {
            //         return true;
            //         //return row.status == "UPLOADED";
            //     },
            // },
            // {
            //     label: "Status",
            //     field: "status",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Uploaded By",
                field: "uploadedBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        // this.columns.find((c) => c.field == "fileURL").linkAction = (
        //     document
        // ) => {
        //     window.open(document.fileURL);
        // };
    },
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.map((t) => t.term),
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "LapidusDocuments?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/lapidusDayCamp/getRegTerms");
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));

            const loadingTask = pdf.createLoadingTask(this.rowClicked.fileURL);

            this.src = loadingTask;

            this.src.promise.then((pdf) => {
                this.numPages = pdf.numPages;
            });

            this.documentDialog = true;
        },
        isPdf() {
            if (!this.rowClicked) return false;

            return ["pdf", "PDF"].includes(
                this.rowClicked.fileURL.split(".").pop()
            );
        },
        isImage() {
            if (!this.rowClicked) return false;

            return ["jpg", "jpeg", "png", "tif", "JPG", "JPEG"].includes(
                this.rowClicked.fileURL.split(".").pop()
            );
        },
        closeDocumentDialog() {
            this.documentDialog = false;
            this.rowClicked = "";
        },
        async save() {
            try {
                this.processing = true;

                await this.$http.post("api/YKCDocuments/save", this.rowClicked);

                this.processing = false;
                this.documentDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = "LapidusDocuments?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
